import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { logOut, updateLocalStorageToken } from '../../../../../containers/resources/utils';

export const customGuideOnBoardList = createSlice({
  name: 'customGuideOnBoardList',
  initialState: {
    cruise: {},
    guidesOnBoard: [],
    processing: false,
    fetching: false,
    message: "",
    error: "",
  },
  reducers: {
    initialStateGuideOnBoardListCustom(state, action) {
      return {
        cruise: {},
        guidesOnBoard: [],
        processing: false,
        fetching: false,
        message: "",
        error: "",
      }
    },
    requesGuideOnBoardListCustom(state, action) {
      return {
        cruise: {},
        guidesOnBoard: [],
        processing: false,
        fetching: true,
        message: "",
        error: "",
      }
    },
    fetchGuideOnBoardListCustomSuccess(state, action) {
      return {
        cruise: action.payload.cruise,
        guidesOnBoard: action.payload.guidesOnBoard,
        processing: false,
        fetching: false,
        message: "",
        error: "",
      }
    },
    fetchGuideOnBoardListCustomError(state, action) {
      return {
        cruise: {},
        guidesOnBoard: [],
        processing: false,
        fetching: false,
        message: "",
        error: action.payload.message,
      }
    }
  }
})

export const fetchGuideOnBoardListCustom = (cruise_id) => dispatch => {
  dispatch(requesGuideOnBoardListCustom())
  axios.get(`cruise/${cruise_id}/guideOnBoardList`)
    .then(json => {
      if (json.data.code === 200) {
        dispatch(fetchGuideOnBoardListCustomSuccess(json.data.data));
      } else if (json.data.code === 202) {
        updateLocalStorageToken(json.data.token);
        dispatch(fetchGuideOnBoardListCustom(cruise_id));
      } else if (json.data.code === 498) {
        logOut();
      } else {
        dispatch(fetchGuideOnBoardListCustomError(json.data.data));
      }
    })
};

export const {
  initialStateGuideOnBoardListCustom,
  requesGuideOnBoardListCustom,
  fetchGuideOnBoardListCustomSuccess,
  fetchGuideOnBoardListCustomError,
} = customGuideOnBoardList.actions;

export default customGuideOnBoardList.reducer;